import * as Yup from 'yup';

export const createClassTypeSchema = Yup.object().shape({
  newEventTypeName: Yup.string()
    .required('Class Name Is Required'),
  newEventDescription: Yup.string()
    .required('Class Description Is Required'),
});